import script from "./NearbyHackathons.vue?vue&type=script&setup=true&lang=js"
export * from "./NearbyHackathons.vue?vue&type=script&setup=true&lang=js"

import "./NearbyHackathons.vue?vue&type=style&index=0&id=23dbcae8&scoped=true&lang=scss"
script.__scopeId = "data-v-23dbcae8"

export default script